import styled from 'styled-components'

interface DividerProps {
  size?: number
  color?: string
  direction?: string
}

export const Divider = styled.div<DividerProps>`
  display: flex;
  height: ${(props) => props.size + 'px'};
  background-color: ${(props) => props.color};
  margin: 10px 0px;
`
Divider.defaultProps = {
  size: 2,
  color: 'black',
}
